"use client";

import { useEffect, useRef } from "react";

export function SiteChrome() {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let raf = 0;
    let scheduled = false;

    const apply = () => {
      scheduled = false;
      const root = document.documentElement;
      const max = root.scrollHeight - root.clientHeight;
      const pct = max > 0 ? (root.scrollTop / max) * 100 : 0;
      const next = Number.isFinite(pct) ? pct : 0;
      const el = barRef.current;
      if (el) el.style.transform = `scaleX(${next / 100})`;
    };

    const onScrollOrResize = () => {
      if (scheduled) return;
      scheduled = true;
      raf = requestAnimationFrame(apply);
    };

    apply();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={barRef}
      className="pointer-events-none fixed inset-x-0 top-0 z-[9999] h-[2px] origin-left scale-x-0 bg-gradient-to-r from-ownly-accent via-[#6ad0ff] to-[var(--ownly-violet)] shadow-[0_0_24px_rgba(43,127,255,0.45)] motion-reduce:hidden"
      aria-hidden
    />
  );
}
